import { render, staticRenderFns } from "./studentInfoPage.vue?vue&type=template&id=5d7c133b&scoped=true&"
import script from "./studentInfoPage.vue?vue&type=script&lang=js&"
export * from "./studentInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./studentInfoPage.vue?vue&type=style&index=0&id=5d7c133b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c133b",
  null
  
)

export default component.exports